module.exports = __webpack_public_path__ + "static/media/default-campaign-image.894dffa7.png";